module.exports = [() => (text) => {
  const endpoint = application.endpoint;
  return endpoint.concat(text);
}];



// WEBPACK FOOTER //
// ./main/filters/api-endpoint-filter.js